/**
 * ResourceFilters - Search and filter controls for resources
 */
import { Card, CardContent } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { 
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { Search } from "lucide-react";
import { PROGRAMS, LIBRARIES } from "./ResourceConstants";

export function ResourceFilters({ 
  searchQuery, 
  onSearchChange, 
  filterProgram, 
  onFilterProgramChange, 
  filterLibrary, 
  onFilterLibraryChange 
}) {
  return (
    <Card className="glass-card mb-6">
      <CardContent className="p-4">
        <div className="flex flex-col sm:flex-row gap-4">
          <div className="flex-1 relative">
            <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-white/40" />
            <Input
              value={searchQuery}
              onChange={(e) => onSearchChange(e.target.value)}
              className="pl-10 bg-white/10 border-white/20 text-white placeholder:text-white/40"
              placeholder="Search by title or description..."
              data-testid="search-input"
            />
          </div>
          
          <Select value={filterProgram || "all"} onValueChange={(v) => onFilterProgramChange(v === "all" ? "" : v)}>
            <SelectTrigger className="w-full sm:w-48 bg-white/10 border-white/20 text-white" data-testid="filter-program">
              <SelectValue placeholder="Filter by program" />
            </SelectTrigger>
            <SelectContent className="bg-emerald-900 border-white/20">
              <SelectItem value="all" className="text-white hover:bg-white/10">All Programs</SelectItem>
              {PROGRAMS.map(prog => (
                <SelectItem key={prog.value} value={prog.value} className="text-white hover:bg-white/10">
                  <span className="flex items-center gap-2">
                    <prog.icon className="w-4 h-4" style={{ color: prog.color }} />
                    {prog.label}
                  </span>
                </SelectItem>
              ))}
            </SelectContent>
          </Select>

          <Select value={filterLibrary || "all"} onValueChange={(v) => onFilterLibraryChange(v === "all" ? "" : v)}>
            <SelectTrigger className="w-full sm:w-48 bg-white/10 border-white/20 text-white" data-testid="filter-library">
              <SelectValue placeholder="Filter by library" />
            </SelectTrigger>
            <SelectContent className="bg-emerald-900 border-white/20">
              <SelectItem value="all" className="text-white hover:bg-white/10">All Libraries</SelectItem>
              {LIBRARIES.map(lib => (
                <SelectItem key={lib.value} value={lib.value} className="text-white hover:bg-white/10">
                  {lib.label}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div>
      </CardContent>
    </Card>
  );
}
